import { motion } from 'framer-motion';
import AnimatedSection from '../common/AnimatedSection';
import useAPI from '../../hooks/useAPI';

// const highlights = [
//   {
//     icon: (
//       <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
//         <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.455 2.456L21.75 6l-1.036.259a3.375 3.375 0 0 0-2.455 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z" />
//       </svg>
//     ),
//     title: 'Industry-Led Curriculum',
//     desc: 'Programs built with Fortune 500 partners',
//   },
//   {
//     icon: (
//       <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
//         <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
//       </svg>
//     ),
//     title: '30+ Expert Trainers',
//     desc: 'Learn from seasoned professionals',
//   },
//   {
//     icon: (
//       <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
//         <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z" />
//       </svg>
//     ),
//     title: '98% Placement Rate',
//     desc: 'Proven career transformation results',
//   },
// ];

const About = () =>{
  const {
    data: aboutData,
    loading,
    error,
  } = useAPI('/about');

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }
  return(
    <>
      {aboutData?.data?.map((item,index)=>(
        <section key={index} id="about" className="py-24 md:py-32 bg-white overflow-hidden">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">

            {/* ── Label + Heading ── */}
            <AnimatedSection>
              <p className="text-primary text-[11px] font-black tracking-[0.22em] uppercase text-center mb-5">
                About Us
              </p>
              <h2 className="text-4xl md:text-5xl lg:text-[3.5rem] font-black text-dark text-center leading-[1.1] tracking-tight max-w-3xl mx-auto">
                {/* Building the{' '}
                <em className="not-italic text-primary">next generation</em>
                {' '}of industry leaders */}
                {item?.title}
              </h2>
              <p className="mt-5 text-dark/45 text-center text-base max-w-lg mx-auto leading-relaxed">
                {item?.subtitle}
              </p>
            </AnimatedSection>

            {/* ── Main grid ── */}
            <div className="mt-20 grid lg:grid-cols-2 gap-16 items-start">

              {/* ── LEFT: Image + Stats ── */}
              <AnimatedSection delay={0.1}>
                <div className="space-y-4">

                  {/* clean image */}
                  <div className="relative aspect-[4/3] rounded-2xl overflow-hidden">
                    <img
                      src={item?.image || "btilogo.jpeg"}
                      alt="BTI"
                      className="w-full h-full object-cover"
                    />
                    {/* very subtle bottom gradient so stats cards sit above it visually */}
                    <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black/30 to-transparent" />
                  </div>

                  {/* ── Stats: sharp bottom cards ── */}
                  <div className="grid grid-cols-3 divide-x divide-slate-100 border border-slate-100 rounded-2xl overflow-hidden bg-white shadow-sm shadow-slate-100">
                    {item?.stats?.map((s, i) => (
                      <motion.div
                        key={i}
                        whileHover={{ backgroundColor: 'rgb(249 250 251)' }}
                        transition={{ duration: 0.15 }}
                        className="group flex flex-col items-center justify-center py-5 px-3 text-center cursor-default"
                      >
                        <span className="text-[1.75rem] font-black tracking-tight text-dark leading-none group-hover:text-primary transition-colors duration-200">
                          {s.number}
                        </span>
                        <span className="mt-1.5 text-[10px] font-semibold text-dark/35 uppercase tracking-[0.12em] leading-tight">
                          {s.label}
                        </span>
                        {/* bottom accent line on hover */}
                        <motion.div
                          className="mt-3 h-[2px] w-6 bg-primary rounded-full"
                          initial={{ scaleX: 0, opacity: 0 }}
                          whileHover={{ scaleX: 1, opacity: 1 }}
                          transition={{ duration: 0.2 }}
                        />
                      </motion.div>
                    ))}
                  </div>

                </div>
              </AnimatedSection>

              {/* ── RIGHT: Text + Highlights ── */}
              <AnimatedSection delay={0.15}>
                <div className="space-y-10">

                  {/* body text */}
                  <div
                    className="space-y-4 text-dark/55 text-[0.97rem] leading-[1.9]"
                    dangerouslySetInnerHTML={{
                      __html: item?.description,
                    }}
                  />

                  {/* ── Highlights ── */}
                  <div className="space-y-3">
                    {item?.features?.map((feat, inde) => (
                      <AnimatedSection key={inde} delay={0.2 + inde * 0.08}>
                        <motion.div
                          whileHover={{ x: 4 }}
                          transition={{ type: 'spring', stiffness: 350, damping: 24 }}
                          className="group flex items-center gap-4 px-5 py-4 rounded-xl border border-slate-100 hover:border-primary/20 hover:shadow-md hover:shadow-primary/[0.06] bg-white transition-all duration-200 cursor-default"
                        >
                          {/* icon box */}
                          {/* <div className="w-10 h-10 rounded-lg bg-slate-50 text-dark/40 flex items-center justify-center flex-shrink-0 group-hover:bg-primary group-hover:text-white transition-all duration-200">
                            {item.icon}
                          </div> */}

                          {/* text */}
                          <div className="flex-1 min-w-0">
                            <p className="text-[0.88rem] font-bold text-dark leading-tight">{feat.title}</p>
                            <p className="text-xs text-dark/35 mt-0.5">{feat.description}</p>
                          </div>

                          {/* right arrow */}
                          <svg className="w-4 h-4 text-slate-200 group-hover:text-primary/40 flex-shrink-0 transition-colors duration-200" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                          </svg>
                        </motion.div>
                      </AnimatedSection>
                    ))}
                  </div>

                </div>
              </AnimatedSection>

            </div>
          </div>
        </section>
      ))}
    </>
  )
}

export default About;